import "./legal.css";

export default function Faq() {
    return (
      <div className="legal-page">
        <h1>Frequently Asked Questions</h1>
  
        <h3>Is the game free to play?</h3>
        <p>
          Yes. You can play for free as a guest. Creating an account unlocks
          rewards and progression features.
        </p>
  
        <h3>Do I need to install anything?</h3>
        <p>
          No installation is required. The game runs entirely in your web browser.
        </p>
  
        <h3>Can I play with friends?</h3>
        <p>
          Yes. You can create private rooms and invite friends using a room code.
        </p>
  
        <h3>Does the game work on mobile devices?</h3>
        <p>
          Yes. The game is fully responsive and works on modern mobile browsers.
        </p>
      </div>
    );
  }
  